jQuery(document).ready(function ($) {

    $navHeight = $('.main-header').outerHeight();
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - $navHeight - 50
        }, 500);
    });

    $('.saldo-check-button').on('click', function (e) {
        e.preventDefault();
        $('body').addClass('overlay');
        $('.saldo-check-window').addClass('show');
    });

    $('.close-saldo-check').on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('overlay');
        $('.saldo-check-window').removeClass('show');
    });

    // If an event gets to the body
    $("body").click(function () {
        $('.saldo-check-window').removeClass('show');
        $('body').removeClass('overlay');
    });

// Prevent events from getting pass .popup
    $(".saldo-check-window, .saldo-check-button").click(function (e) {
        e.stopPropagation();
    });


    if ($(window).width() < 1025) {

        $('.toggle-nav').on('click', function () {
            $('.hamburger').toggleClass('is-active');
            $('.main-nav').toggleClass('show');
            $('body').toggleClass('no-scroll');
        });

        $('.menu-item').on('click', function () {
            $('.main-nav').removeClass('show');
            $('.hamburger').removeClass('is-active');
            $('body').removeClass('no-scroll');
        });

        /*$("body").click(function(){
            $('.main-nav').removeClass('show');
            $('body').removeClass('overlay');
            $('body').removeClass('no-scroll');
            $('.hamburger').removeClass('is-active');
        });

        $(".menu-item, .toggle-nav").click(function(e){
            e.stopPropagation();
        });*/
    }

});
